<template>
  <div class="charge-order-list" v-loading="loading">
    
    <div class="h_line"></div>
    <div class="con-body">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column fixed="left" prop="txnId" :label="$t('charge.transaction_id')" width="140"></el-table-column>
        <el-table-column prop="startTime" :label="$t('charge.order_start_time')" width="140"></el-table-column>
        <el-table-column prop="endTime" :label="$t('charge.order_end_time')" width="140"></el-table-column>
        <el-table-column :label="$t('charge.order_total_price')" width="140">
          <template slot-scope="scope">
            {{ scope.row.amountTotal||'-'}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('charge.transaction_type')">
          <template slot-scope="scope">
            {{ trade_mark_arr[scope.row.tradeMark||0] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('charge.vin')">
          <template slot-scope="scope">
            {{ scope.row.tradeMark===5?scope.row.vin||'-':'-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('charge.loss_energy')" width="160">
          <template slot-scope="scope">
            {{ scope.row.lossEnergyTotal||0 }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('charge.meter_start')">
          <template slot-scope="scope">
            {{ scope.row.meterStart||0 }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('charge.meter_end')">
          <template slot-scope="scope">
            {{ scope.row.meterEnd||0 }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('charge.location')" width="120">
          <template slot-scope="scope">
            {{ getDeviceField(scope.row.pileId, 'location') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('charge.pile_code')" width="140">
          <template slot-scope="scope">
            {{ getDeviceField(scope.row.pileId, 'pileCode') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('charge.gun_no')">
          <template slot-scope="scope">
            {{ scope.row.gunId||'-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('charge.physical_card_hex')" width="140">
          <template slot-scope="scope">
            {{ scope.row.physicalCardHex||'-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('charge.user_id')" prop="userId"></el-table-column>
        

        <el-table-column :label="$t('charge.stop_reason')" prop="stopReasonText">
          <template slot-scope="scope">
            {{ scope.row.stopReasonText||'-' }}
          </template>
        </el-table-column>

        <el-table-column fixed="right" width="120" :label="$t('charge.order_status')">
          <template slot-scope="scope">
            <span :class="'order-status'+(scope.row.status || 0)">
            {{ order_status_arr[scope.row.status||0] }}
            </span>
            
          </template>
        </el-table-column>
        
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import chargeApi from "@/api/chargeApi/list";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      trade_mark_arr: this.$t('charge.transaction_type_arr'),
      order_status_arr: this.$t('charge.order_status_arr'),
      deviceData: [],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      devSelect: [],
    };
  },
  computed: {
    getDeviceField() {
      // 返回一个函数，便于带参数查找
      return (id, field) => {
        const item = this.deviceData.find(d => d.id === id);
        return item ? item[field] : undefined;
      };
    }
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      chargeApi.orderList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          console.log(resData)
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count)
        }
      });
    },
    getDeviceData() {
      chargeApi.dataList({
        page: 1,
        pageSize: 500
      }).then((res) => {
        if (res.data.code === 1000) {
          const resData = res.data.data.list;
          this.deviceData = resData.map(({ guns, ...rest }) => rest);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    }
  },
  mounted() {
    this.getDeviceData();
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less'>
.charge-order-list {
  width: 100%;
  .form-info{
    padding-left: 10px;
    .el-form-item__label{
      width:85px;
    }
  }
  .order-status0{
    color: #FF4D4F;
  }
  .order-status1{
    color: #009933;
  }
  .order-status2{
    color: #006699;
  }
  .order-status3{
    color: #009933;
  }
}
</style>